import BookFlights from "../components/flights/BookFlights";
import TripPicksForYou from "../components/flights/TripPicksForYou";
import FlightImage from "../../src/assets/img/flights-image.webp";
import CommonHero from "../components/common/CommonHero";
import GetTheBestTravelDeal from "../components/common/GetTheBestTravelDeal";
import { useEffect } from "react";

const FlightsPage = () => {
   useEffect(() => {
        document.getElementById("title-page").innerHTML = "TripNest | Group tour";
      }, []);
  return (
    <>
      <CommonHero imgUrl={FlightImage} text="Explore Flights" />
      <BookFlights />
      <TripPicksForYou />
      <GetTheBestTravelDeal/>
    </>
  );
};

export default FlightsPage;
